export const VideoPlayerConfig = {
    SEEK_SECONDS: 10,
    VOLUME_CONTROL: 0.1,
    SEEK_THROTTLE_DURATION: 750,
};
